import "./App.css";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import Footer from "./Components/Common/Footer";
import "./main.scss";
import { store, persistor } from "./Redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ConfigProvider } from "antd";
import ThemeConfig from "./Config/theme";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <ConfigProvider
            theme={{
              ...ThemeConfig,
            }}
          >
            <AppRoutes />
            <Footer />
          </ConfigProvider>
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
